import BaseValidator from './BaseValidator';

class CertificationItemValidator extends BaseValidator {
  validationErrors: any[];
  validity: any;
  customTitle: any;
  type: any;
  yearFrom: any;
  yearTo: any;
  constructor(opts: any = {}) {
    super();
    this.validationErrors = [];
    this.validity = null;
    this.customTitle = opts.customTitle;
    this.type = opts.type;
    this.yearFrom = opts.yearFrom;
    this.yearTo = opts.yearTo;
  }

  validate() {
    const validityCheck = Promise.all([
      this.validateType(),
      this.validateCustomTitle(),
      this.validateYearRange(),
    ]).then((responses) => {
      if (this.validationErrors.length === 0) {
        return Promise.resolve({ valid: true });
      } else {
        return Promise.resolve({ valid: false, errors: this.validationErrors });
      }
    });
    return validityCheck;
  }

  dealValidationResult(type, res) {
    if (res.success) {
      return res;
    } else {
      this.validationErrors.push({
        success: false,
        type,
        message: res.err,
      });
      return res;
    }
  }

  validateType() {
    return super.cannotEmpty(this.type).then((res) => {
      this.dealValidationResult('Certification Title', res);
    });
  }

  validateCustomTitle() {
    if (this.type === 'Other' && this.customTitle === '') {
      return this.dealValidationResult('Custom Title', {
        success: false,
        err: 'Custom title cannot be empty when you select other certification.',
      });
    }
  }

  validateYearRange() {
    Promise.all([
      super.cannotEmpty(this.yearFrom),
      super.cannotEmpty(this.yearTo),
    ]).then((results: any) => {
      if (results[0].success && results[1].success) {
        return this.checkYearRangeFormat(results).then((res) => {
          this.dealValidationResult('Duration', res);
        });
      } else {
        this.dealValidationResult('Duration', {
          success: false,
          err: 'Both fields cannot be empty.',
        });
      }
    });
  }

  checkYearRangeFormat(results) {
    return new Promise((resolve, reject) => {
      if (results[0].value > results[1].value) {
        resolve({
          success: false,
          err: 'Finished year should be same or after the start year.',
        });
      } else {
        resolve({ success: true });
      }
    });
  }
}

export default CertificationItemValidator;
